<template>
    <div v-if="events.length > 0">
        <v-sheet tile color="grey lighten-3">
            <v-row dense>
                <v-col cols="12" sm="1" md="1">
                    <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="1" class="text-center">
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on" class="month-dropDown">
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Month</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                                <v-list-item-title>Week</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Day</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col cols="12" sm="3" md="5" class="text-center">
                    <h1 class="curr-month">{{ curr_month || title }}</h1>
                </v-col>
                <v-col cols="12" sm="2" md="2" align="right">
                    <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays"
                        class="ma-2"></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="1" align="right">
                    <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today</v-chip>
                </v-col>
                <v-col cols="12" sm="1" md="1" align="right">
                    <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet height="520">
            <v-calendar ref="calendar" v-model="value" :weekdays="weekday" color="primary" :type="type" :events="events"
                :event-overlap-mode="column" :event-overlap-threshold="1000" :max-events="1000"
                :event-color="getEventColor" @click:event="showEvent" @click:more="viewDay" @click:day="getdata">
            </v-calendar>
        </v-sheet>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="headline">{{ tempevents.name }}</v-card-title>
                <v-card-text>
                    <div class="headline mb-2">Description: {{ tempevents.description }}</div>
                    <v-chip class="mr-2" color="lightgreen" text-color="white">
                        <v-icon left>mdi-brightness-5</v-icon>
                        Class: {{ tempevents.std }}
                    </v-chip>
                    <div>Start: {{ tempevents.start }}</div>
                    <div>End: {{ tempevents.end }}</div>
                    <div v-if="tempevents.attachment && tempevents.attachment.length > 0">
                        <div class="mt-2">Attachments:</div>
                        <div v-for="(attachment, index) in tempevents.attachment" :key="index"
                            style="margin-bottom: 8px;">
                            {{ index + 1 }}. <a :href="basepath + attachment.link" target="_blank">Attachment</a>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        dialog: false,
        value: "",
        basepath: null,
        type: "month",
        typeToLabel: {
            month: "Month",
            week: "Week",
            day: "Day",
        },
        eventColors: {},
        weekday: [1, 2, 3, 4, 5, 6, 0], // Default weekdays set to Mon - Sun
        weekdays: [
            { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
            { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] }, // Default selection
            { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
        ],
        events: [],
        tempevents: { name: "", description: "", std: "", grno: "", start: "", end: "", attachment: [] },
        title: "",
        curr_month: null,
    }),

    updated() {
        this.$nextTick().then(() => {
            if (this.$refs.calendar && this.$refs.calendar.value != "") {
                let date = this.$refs.calendar.value;
                var no = date.split("-");
                this.curr_month = this.months[parseInt(no[1])];
            }
        });
    },

    methods: {
        showEvent({ event }) {
            this.tempevents = { ...event };
            this.dialog = true;
        },
        viewDay({ date }) {
            this.value = date;
            this.type = "day";
        },
        setToday() {
            this.value = "";
            this.curr_month = null;
        },
        // Generate a fixed color based on the event name or ID
        generateColorFromName(name) {
            let hash = 0;
            for (let i = 0; i < name.length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            const color = '#' + ((hash & 0x00FFFFFF) | 0x1000000).toString(16).substring(1).toUpperCase();
            return color;
        },
        getEventColor(event) {
            // Generate a fixed color based on the event name
            return this.generateColorFromName(event.name);
        },
        dateTime() {
            let dt = this.formatDate(this.datetime, true);
            const formData = {
                datetime: dt,
            };
            axios
                .post("tryNError/dateTime", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        getdata({ day }) {
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        },
        formatDate(a, withTime) {
            return withTime ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}` : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
        },
        getMonthYYYYMMDD(date) {
            var num_month = date.split("-");
            var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            return months[parseInt(num_month[1])];
        },
    },
    mounted() {
        this.basepath = localStorage.getItem("awspath");
        axios.get("parent/getCalendar")
            .then(res => {
                if (res.data.msg == "200") {
                    if (res.data.eventInfoNew.length !== 0) {
                        this.events = res.data.eventInfoNew.map(event => {
                            return {
                                name: event.name,
                                start: event.start,
                                end: event.to_date,
                                color: this.getEventColor(event),
                                description: event.description,
                                std: event.std,
                                grno: event.grno,
                                attachment: event.attachment
                            };
                        });
                    }
                    if (this.$refs.calendar && this.$refs.calendar.start) {
                        this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
};
</script>

<style scoped>
.month-dropDown {
    margin-top: 2%;
}

.event-card {
    cursor: pointer;
}

.event-card-title {
    font-weight: bold;
}

.curr-month {
    font-size: 30px;
    color: #8c9eff;
    display: inline-block;
    -webkit-transform: scale(1.5, 1);
    -moz-transform: scale(1.5, 1);
    -ms-transform: scale(1.5, 1);
    -o-transform: scale(1.5, 1);
}
</style>